import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Notiflow } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type CreateNotiflowInput = {
  name: string;
  handle: string;
};

export const useCreateNotiflow = (
  projectId: string,
  options: Omit<UseMutationOptions<Notiflow, UnprocessableEntityError, CreateNotiflowInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Notiflow, UnprocessableEntityError, CreateNotiflowInput, unknown>({
    mutationFn: async (input: CreateNotiflowInput): Promise<Notiflow> => {
      const response = await api.post<Notiflow>(`/projects/${projectId}/notiflows`, underscore(input));
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "notiflows"],
      });
    },
    ...options
  });
};
